import Accordion from '../stories/components/accordion-tabs/accordion-tabs.init';
import Button from '../stories/blocks/button/button.init';
import CardDeck from '../stories/components/card-deck/card-deck.init';
// import CardDeckBlogCategory from '../stories/components/card-deck/xhr/blog-category.init';
// import CardDeckCalendarCards from '../stories/components/card-deck/xhr/calendar-cards.init';
// import CardDeckNewsroom from '../stories/components/card-deck/xhr/newsroom.init';
import ContentFilter from '../stories/components/content-filter/content-filter.init';
import CookieConsent from '../stories/components/cookie-consent/cookie-consent.init';
import Details from '../stories/blocks/details/details.init';
import Dialog from '../stories/components/dialog/dialog.init';
import Figure from '../stories/components/figure/figure.init';
import FilteredListing from '../stories/components/card-deck/filtered-listing.init';
import FintactixCalculator from '../stories/components/fintactix-calculator/fintactix-calculator.init';
import Form from '../stories/components/form/form.init';
import GlobalAlert from '../stories/blocks/global-alert/global-alert.init';
import GlobalHeader from '../stories/components/global-header/global-header.init';
import GlobalNav from '../stories/components/global-nav/global-nav.init';
import GlobalSearch from '../stories/components/global-search/global-search.init';
import LanguageSelect from '../stories/blocks/select/language-select.init';
import Marquee from '../stories/components/global-marquee/marquee.init';
import MenuToggle from '../stories/blocks/menu-toggle/menu-toggle.init';
import NavItem from '../stories/blocks/nav-item/nav-item.init';
import Openstreetmap from '../stories/components/openstreetmap/openstreetmap.init';
import ShareWidget from '../stories/components/share-widget/share-widget.init';
import Splide from '../stories/layouts/carousel/splide.init';
import Timeline from '../stories/components/timeline/timeline.init';
// import VideoLibrary from '../stories/layouts/video-library/video-library.init';

import addIeBodyClass from './lib/detectIE11';
import domReady from './lib/domReady';
import externalLinks from './lib/externalLinks';
import initModule from './lib/initModule';

// Intialize scripts here requiring DOM access.
//
// Any modules imported here should export a function
// that takes a node as its only parameter.
// Import the module then initialize it below inside
// domScripts(), calling initModule() and passing in
// the function and a selector that aligns with the element
// you want to pass into the module.
// initModule() calls the method on each instance
// of the selector passed, so your script can assume
// it is working on a unique DOM node.
//
// example:
// import coolThing from '../ui/blocks/CoolThing/cool-thing.init';
// initModule(coolThing, '.cool-thing');

const domScripts = () => {
  initModule(Accordion, '.accordion-tabs');
  initModule(addIeBodyClass, 'body');
  initModule(Button, '.button--clipboard');
  initModule(CardDeck, '.card-deck');
  // initModule(CardDeckBlogCategory, 'form.card-deck--blog-category');
  // initModule(CardDeckNewsroom, 'form.card-deck--newsroom');
  // initModule(CardDeckCalendarCards, 'form.card-deck--calendar');
  initModule(ContentFilter, '.content-filter');
  initModule(CookieConsent, '.cookie-consent');
  initModule(Details, '.details');
  initModule(Dialog, '.dialog');
  initModule(externalLinks, 'body');
  initModule(Figure, '.figure:not(.timeline .figure):not(.card .figure)');
  initModule(FilteredListing, 'form.js-filtered-listing');
  initModule(FintactixCalculator, 'iframe[src^="https://www.fintactix.com"]');
  initModule(Form, '.form');
  initModule(GlobalAlert, '.global-alert');
  initModule(GlobalHeader, '.global-header');
  initModule(GlobalNav, '.global-nav');
  initModule(GlobalSearch, '.global-search');
  initModule(LanguageSelect, '#lang-select');
  initModule(Marquee, '.marquee');
  initModule(MenuToggle, '.menu-toggle');
  initModule(Openstreetmap, '.openstreetmap');
  initModule(NavItem, 'button.nav-item');
  initModule(ShareWidget, '.share-widget');
  initModule(Splide, '.splide-container');
  initModule(Timeline, '.timeline');
  // initModule(VideoLibrary, '.video-library');
};

// domReady ensures our scripts fire inside Storybook
// even when navigating component to component,
// calling the passed function on DOMContentLoaded
// and each time the page changes, using MutationObserver
domReady(domScripts);
